import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, Multilingual, DropdownSelector } from 'hyperdb-utils';

const MultilingualField = Multilingual(TextInput);

class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.api.zone.getObjects({
      propName: 'area_zones',
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
  render() {
    return (
      <fieldset>
        <DropdownSelector
          label="Zone"
          name="zone"
          value={ this.props.objectData.zone }
          options={ this.zonesOptions(this.props.api.getState('zone').area_zones) }
          onChange={ this.handleChange.bind(this, 'zone') }
        />
        <MultilingualField
          label="Name"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
          availableLocales={ this.props.availableLanguages }
        />
      </fieldset>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.updateEditedObject({ attributeName, value });
  }
  zonesOptions(zones) {
    if (!zones) return [];
    return zones.map(z => ({ name: z.name[this.props.defaultLanguage], value: z.id }));
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  zones: React.PropTypes.array,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
  defaultLanguage: React.PropTypes.string,
};

export default HyperdbForm(Form, {
  namespace: 'area',
  mountedUrl: '/areas',
  titleNew: 'Create new area',
  titleEdit: 'Edit area',
  displayName: (object) => object.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/area/containers/Form.jsx